<template>
  <div class="upload">
    <!-- <el-dialog
      title="留归集团用户使用协议"
      :visible.sync="vis"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form ref="form" label-width="70px">
        <h1 class="fication">一、特别提醒</h1>
        <h2 class="jinggao">{{remind.yi}}</h2>
        <h2 class="jinggao">{{remind.er}}</h2>
        <h2 class="jinggao">{{remind.san}}</h2>
        <h1 class="fication">二、用户注册</h1>
        <h2 class="jinggao">{{registered.yi}}</h2>
        <h2 class="jinggao">{{registered.er}}</h2>
        <h2 class="jinggao">{{registered.san}}</h2>
        <h1 class="fication">三、账号安全</h1>
        <h2 class="jinggao">{{Safety.yi}}</h2>
        <h2 class="jinggao">{{Safety.er}}</h2>
        <h2 class="jinggao">{{Safety.san}}</h2>
        <h1 class="fication">四、用户声明与保证</h1>
        <h2 class="jinggao">{{surety.yi}}</h2>
        <h2 class="jinggao">{{surety.er}}</h2>
        <h2 class="jinggao">{{surety.san}}</h2>
        <h3 class="jinggao">{{surety.sanYi}}</h3>
        <h3 class="jinggao">{{surety.sanEr}}</h3>
        <h3 class="jinggao">{{surety.sanSan}}</h3>
        <h3 class="jinggao">{{surety.sanSi}}</h3>
        <h3 class="jinggao">{{surety.sanWu}}</h3>
        <h2 class="jinggao">{{surety.si}}</h2>
        <h3 class="jinggao">{{surety.siYi}}</h3>
        <h3 class="jinggao">{{surety.siEr}}</h3>
        <h3 class="jinggao">{{surety.siSan}}</h3>
        <h3 class="jinggao">{{surety.siSi}}</h3>
        <h3 class="jinggao">{{surety.siWu}}</h3>
        <h3 class="jinggao">{{surety.siLiu}}</h3>
        <h3 class="jinggao">{{surety.siQi}}</h3>
        <h3 class="jinggao">{{surety.siBa}}</h3>
        <h3 class="jinggao">{{surety.siJiu}}</h3>
        <h2 class="jinggao">{{surety.wu}}</h2>
        <h2 class="jinggao">{{surety.liu}}</h2>
        <h2 class="jinggao">{{surety.qi}}</h2>
        <h1 class="fication">五、服务内容</h1>
        <h2 class="jinggao">{{service.yi}}</h2>
        <h2 class="jinggao">{{service.er}}</h2>
        <h2 class="jinggao">{{service.san}}</h2>
        <h1 class="fication">六、服务变更、中断或终止</h1>
        <h2 class="jinggao">{{changes.yi}}</h2>
        <h2 class="jinggao">{{changes.er}}</h2>
        <h2 class="jinggao">{{changes.san}}</h2>
        <h1 class="fication">七、知识产权</h1>
        <h2 class="jinggao">{{rights.yi}}</h2>
        <h2 class="jinggao">{{rights.er}}</h2>
        <h1 class="fication">八、隐私保护</h1>
        <h2 class="jinggao">{{privacy.yi}}</h2>
        <h2 class="jinggao">{{privacy.yiYi}}</h2>
        <h2 class="jinggao">{{privacy.yiEr}}</h2>
        <h2 class="jinggao">{{privacy.yiSan}}</h2>
        <h2 class="jinggao">{{privacy.yiSi}}</h2>
        <h2 class="jinggao">{{privacy.yiWu}}</h2>
        <h2 class="jinggao">{{privacy.er}}</h2>
        <h2 class="jinggao">{{privacy.san}}</h2>
        <h2 class="jinggao">{{privacy.si}}</h2>
        <h1 class="fication">九、免责声明</h1>
        <h2 class="jinggao">{{Disclaimer.yi}}</h2>
        <h2 class="jinggao">{{Disclaimer.er}}</h2>
        <h2 class="jinggao">{{Disclaimer.san}}</h2>
        <h2 class="jinggao">{{Disclaimer.si}}</h2>
        <h2 class="jinggao">{{Disclaimer.wu}}</h2>
        <h2 class="jinggao">{{Disclaimer.liu}}</h2>
        <h2 class="jinggao">{{Disclaimer.qi}}</h2>
        <h1 class="fication">十、违约赔偿</h1>
        <h2 class="jinggao">{{contract.yi}}</h2>
        <h2 class="jinggao">{{contract.er}}</h2>
        <h1 class="fication">十一、其他条款</h1>
        <h2 class="jinggao">{{other.yi}}</h2>
        <h2 class="jinggao">{{other.er}}</h2>
        <h2 class="jinggao">{{other.san}}</h2>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subUpload" style="width: 134px;">已阅读</el-button>
      </div>
    </el-dialog>-->
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    isbool: {
      // 点击的用户协议
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //留归用户协议
      xieyi: {
        remind: {
          tixing: "一、特别提醒",
          yi:
            "1.特别提醒您（用户）在注册成为留归集团正式用户之前，请认真阅读《留归集团用户使用协议》（以下简称为“协议”）。为确保您充分理解本协议中的条款，请您仔细阅读并选择是否接受本协议，您点击“接受”本协议条款按钮且完成全部注册程序后，才能成为留归集团正式用户，并享受留归集团的各类服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意本协议各项条款的约束。",
          er:
            "2.留归集团承诺按照本协议的规定及不时发布的操作规则提供基于互联网以及移动网的相关服务（以下简称为“网络服务”）。为获得网络服务，您应当接受本协议的全部条款，并按照页面上的提示完成全部的注册程序。",
          san:
            "3.本协议会随网站新功能不时更新，更新后的协议一旦公布将立即代替原协议，恕不再另行通知，您可在网站中查阅最新协议。若您不同意新协议，有权选择停止享受留归集团所提供的网络服务，但若您继续使用，则视为接受留归集团对本协议相关条款的修改。",
        },
        registered: {
          zhuce: "二、用户注册",
          yi:
            "1.用户在享受留归集团提供的网络服务前需注册一个账号，账号应与手机号码绑定注册，请用户使用未曾与留归集团绑定的手机号码。",
          er:
            "2.如果用户注册申请时有涉嫌虚假注册、滥用他人名义注册或其他不能得到许可的理由，留归集团有权拒绝其注册申请。",
          san:
            "3.用户在注册及使用本网络服务时，留归集团会识别用户的个人信息以便在必要时联系用户，或为用户提供更好的服务。留归集团识别的信息包括但不限于用户姓名、手机号码、地址等。留归集团同意对这些信息的使用受限于第三方用户个人隐私信息保护的约束。",
        },
        Safety: {
          anquan: "三、账号安全",
          yi:
            "1.用户注册成功后将成为留归集团正式用户，会获得一个用户账号及相应密码。该账号和密码由用户负责保管，并有权随时使用账号、密码登录。",
          er:
            "2.用户通过该账号进行的所有活动和事件都负有法律责任，因而不得以任何形式擅自转让或授权给他人使用。",
          san:
            "3.如果用户不慎泄露账号密码，可能会导致不良的法律后果，因此不管任何原因导致的用户账号安全受到威胁，用户应立即和留归集团客服人员联系，否则后果自负。",
        },
        surety: {
          baozhang: "四、用户声明与保证",
          yi:
            "1.用户承诺其为具有完全民事行为能力的民事主体，且具有达成交易、履行其义务的能力。",
          er:
            "2.用户有义务提供注册账号的真实资料，并保证如手机号码、地址、邮箱等信息的有效性及安全性，保证留归集团工作人员可以通过上述联系方式与用户取得联系。同时，用户有义务在相关资料实际变更时，及时更新有关注册资料。因用户提供资料的真实性问题导致协议双方或第三方的任何损失均由用户承担。",
          san: "3.用户在享受留归集团网络服务的过程中，必须遵循以下原则:",
          sanYi: "（1）遵守中国有关的法律和法规；",
          sanEr: "（2）不得为任何非法目的而使用留归集团网络服务；",
          sanSan: "（3）遵守所有与网络服务有关的网络协议、规定和程序；",
          sanSi:
            "（4）不得利用留归集团系统进行任何可能对互联网的正常运转造成不利影响的行为；",
          sanWu:
            "（5）不得利用留归集团网络服务系统进行任何不利于留归集团的行为。",
          si:
            "4.用户不得使用留归集团账号或网站等制作、上传、发送、传播敏感信息和违反国家法律制度的信息，包括但不限于下列信息:",
          siYi: "（1）反对宪法所确定的基本原则的；",
          siEr:
            "（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；",
          siSan: "（3）损害国家荣誉和利益的；",
          siSi: "（4）煽动民族仇恨、民族歧视，破坏民族团结的；",
          siWu: "（5）破坏国家宗教政策，宣扬邪教和封建迷信的；",
          siLiu: "（6）散布谣言，扰乱社会秩序，破坏社会稳定的；",
          siQi: "（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；",
          siBa: "（8）侮辱或者诽谤他人，侵害他人合法权益的；",
          siJiu: "（9）含有法律、行政法规禁止的其他内容的。",
          wu:
            "5.用户有权更改、删除在留归集团中的个人资料、注册信息及传送内容等，但删除有关信息的同时也会删除储存系统中的文字和图片。用户需承担该风险。",
          liu:
            "6.如因用户违反本协议中的任何条款，留归集团有权依据本协议终止对违约用户提供服务。",
          qi:
            "7.如用户注册留归集团帐号后长期（连续超过一年）不登录该帐号，留归集团有权回收该帐号，以免造成资源浪费，由此带来问题均由用户自行承担。",
        },
        service: {
          nierong: "五、服务内容",
          yi:
            "1.留归集团网络服务的具体内容由留归集团根据实际情况提供，包括但不限于授权用户通过其账号上传、搜索，并向关联用户推送相关信息、授权用户对其进行收录、分享等。留归集团有权对其提供的网络服务进行升级或其他调整，其更新内容均以网站更新的方式通知用户，不再单独通知用户。",
          er:
            "2. 留归集团提供的部分网络服务为收费项目，用户使用收费网络服务需要向留归集团支付一定的费用。对于收费的网络服务，留归集团会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该收费网络服务。如用户拒绝支付相关费用，则留归集团有权不向用户提供该收费网络服务。",
          san:
            "3.留归集团仅提供相关网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。",
        },
        changes: {
          zhongzhi: "六、服务变更、中断或终止",
          yi:
            "1.鉴于网络服务的特殊性（包括但不限于不可抗力、网络稳定性、系统稳定性、技术故障、用户所在位置、用户关机、用户手机病毒或恶意的网络攻击行为及其他任何技术、互联网络、通信线路、内容侵权等原因），用户同意留归集团有权随时中断或终止部分或全部网络服务，留归集团将尽可能及时地以合理方式通知用户，并尽可能在第一时间对此进行修复。但由此导致用户不能发送和接受信息、或错发信息等问题，留归集团不承担任何责任，用户须承担以上风险。",
          er:
            "2.用户理解，留归集团需要定期或不定期地对提供网络服务的平台或相关设备进行检修和维护，如因此类情况而造成服务在合理期间内的中断，留归集团将尽可能事先通知，但无需为此承担任何责任。",
          san:
            "3.用户提供的个人资料不真实、用户违反法律法规国家政策或本协议规定，留归集团有权随时中断或终止向用户提供的网络服务，而无需对用户或任何第三方承担任何责任。",
        },
        rights: {
          chanquan: "七、知识产权",
          yi:
            "1.留归集团提供的网络服务中包含的任何文本、图片、图形、音频、视频资料均受版权、商标权、专利权及其它财产权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布，或被用于其他任何商业目的。用户不得擅自复制、修改、编纂上述内容，或创造与内容有关的衍生产品。",
          er:
            "2.留归集团为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图象、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。",
        },
        privacy: {
          baihu: "八、隐私保护",
          yi:
            "1.保护用户隐私是留归集团的一项基本政策，留归集团将采取各种制度、安全技术和程序等措施保护用户隐私和个人数据不被未经授权的访问、使用或泄漏，并保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在留归集团的非公开内容，但下列情况除外：",
          yiYi: "（1）事先获得用户的明确授权；",
          yiEr: "（2）根据有关的法律法规要求；",
          yiSan: "（3）按照相关政府主管部门的要求；",
          yiSi: "（4）为维护社会公众的利益；",
          yiWu: "（5）为维护留归集团的合法权益。",
          er:
            "2.用户在注册留归集团帐号时，需要提供一些必要的信息，例如：姓名、电话、邮箱、性别、出生年月等。为向用户提供帐号注册服务或进行用户身份识别，需要用户填写手机号码；部分功能需要用户授权使用用户的相机或相册；部分功能需要用户授权访问用户的手机通讯录等。若用户不授权或提供的信息不完整，则无法使用本服务或在使用过程中受到限制。用户授权提供的信息，留归集团承诺将采取措施保护用户的个人信息安全。",
          san:
            "3.为了向用户提供更好的用户体验，提高留归集团的服务质量，留归集团可能会与第三方合作向用户提供相关的网络服务。在此情况下，如该第三方同意承担与留归集团同等的用户隐私保护责任，则用户同意留归集团有权将用户的注册资料等提供给该第三方。",
          si:
            "4.在不透露单个用户隐私资料的前提下，留归集团有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。",
        },
        Disclaimer: {
          shengming: "九、免责声明",
          yi:
            "1.用户明确同意其使用留归集团网络服务时存在的风险完全由自己承担，因而，其使用留归集团网络服务时产生的一切后果也由自己承担，留归集团对用户不承担任何责任。",
          er:
            "2.用户在享受留归集团提供的网络服务过程中应遵守国家法律法规及政策规定，对其所制作、上传、发送、传播的信息和内容承担一切法律责任，与留归集团无关。",
          san:
            "3.留归集团不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。",
          si:
            "4.在留归集团网站上向用户显示、推送的任何信息和内容如是留归集团利用技术手段、根据用户指令从互联网任何第三方网站搜索、定位、匹配后推荐给用户，而非留归集团单方制作的，则该显示、推送的信息和内容并不代表留归集团的观点，留归集团不对上述信息的准确性和正确性负责。",
          wu:
            "5.留归集团提供的网络服务中所包含的任何文本、图片、标识、音频、视频资料均为教学用途，不涉及任何实体物品的商业活动。",
          liu:
            "6.在留归集团网页上向用户显示、推送的任何信息和内容，或用户自行上传的内容，如存在侵权任何第三方知识产权的嫌疑，权利人和相关利害关系人应当向留归集团发出权利通知，留归集团经过核实后，根据有关法律法规有权采取包括但不限于断开该侵权内容的链接或删除并停止传输该侵权内容，但留归集团并不对该侵权内容承担法律责任。",
          qi:
            "7.用户违反本协议的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括第三方及留归集团的合理律师费，用户同意赔偿留归集团，使之免受损害。",
        },
        contract: {
          peichang: "十、违约赔偿",
          yi:
            "1.如因留归集团违反有关法律、法规或本协议项下的任何条款而给用户造成损失，留归集团同意承担由此造成的损害赔偿责任。",
          er:
            "2.用户同意保障和维护留归集团及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款，而给留归集团或任何其他第三方造成的损失，用户同意承担由此造成的损害赔偿责任。",
        },
        other: {
          tiaokuan: "十一、其他条款",
          yi:
            "1.本协议所定的任何条款无论因何种原因部分或全部无效或不具有执行力时，其他条款仍有效并具备约束力。",
          er:
            "2.本协议的订立、执行和解释及纠纷的解决均应适用中华人民共和国法律并受中华人民共和国法院管辖。如双方就本协议内容或执行发生任何纠纷或争议，首先应友好协商解决。协商不成的，任何一方均应向留归集团所在地的有管辖权的人民法院提起诉讼。",
          san:
            "3.本协议的版权归留归集团所有，本协议各项条款内容的最终解释权及修改权归留归集团所有。",
        },
      },
      TempName: "",
      show: false,
      vis: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    closeDialog() {
      this.$emit("close-dialogStatus", true);
    },
    subUpload() {
      this.vis = false;
    },
  },
  watch: {
    isbool(newValue, oldValue) {
      // console.log("22", this.show);
      // console.log(this.xieyi);
      this.show = newValue;
      let arr = [
        this.xieyi.remind.tixing,
        this.xieyi.remind.yi,
        this.xieyi.remind.er,
        this.xieyi.remind.san,
        this.xieyi.registered.zhuce,
        this.xieyi.registered.yi,
        this.xieyi.registered.er,
        this.xieyi.registered.san,
        this.xieyi.Safety.anquan,
        this.xieyi.Safety.yi,
        this.xieyi.Safety.er,
        this.xieyi.Safety.san,
        this.xieyi.surety.baozhang,
        this.xieyi.surety.yi,
        this.xieyi.surety.er,
        this.xieyi.surety.san,
        this.xieyi.surety.sanYi,
        this.xieyi.surety.sanEr,
        this.xieyi.surety.sanSan,
        this.xieyi.surety.sanSi,
        this.xieyi.surety.sanWu,
        this.xieyi.surety.si,
        this.xieyi.surety.siYi,
        this.xieyi.surety.siEr,
        this.xieyi.surety.siSan,
        this.xieyi.surety.siSi,
        this.xieyi.surety.siWu,
        this.xieyi.surety.siLiu,
        this.xieyi.surety.siQi,
        this.xieyi.surety.siBa,
        this.xieyi.surety.siJiu,
        this.xieyi.surety.wu,
        this.xieyi.surety.liu,
        this.xieyi.surety.qi,
        this.xieyi.service.nierong,
        this.xieyi.service.yi,
        this.xieyi.service.er,
        this.xieyi.service.san,
        this.xieyi.changes.zhongzhi,
        this.xieyi.changes.yi,
        this.xieyi.changes.er,
        this.xieyi.changes.san,
        this.xieyi.rights.chanquan,
        this.xieyi.rights.yi,
        this.xieyi.rights.er,
        this.xieyi.privacy.baihu,
        this.xieyi.privacy.yi,
        this.xieyi.privacy.yiYi,
        this.xieyi.privacy.yiEr,
        this.xieyi.privacy.yiSan,
        this.xieyi.privacy.yiSi,
        this.xieyi.privacy.yiWu,
        this.xieyi.privacy.er,
        this.xieyi.privacy.san,
        this.xieyi.Disclaimer.shengming,
        this.xieyi.Disclaimer.yi,
        this.xieyi.Disclaimer.er,
        this.xieyi.Disclaimer.san,
        this.xieyi.Disclaimer.si,
        this.xieyi.Disclaimer.wu,
        this.xieyi.Disclaimer.liu,
        this.xieyi.Disclaimer.qi,
        this.xieyi.contract.peichang,
        this.xieyi.contract.yi,
        this.xieyi.contract.er,
        this.xieyi.other.tiaokuan,
        this.xieyi.other.yi,
        this.xieyi.other.er,
        this.xieyi.other.san,
      ];
      let str = arr.join(" <br/> ");
      if (newValue === true) {
        this.$dialog
          .alert({
            confirmButtonText: "已阅读",
            title: "留归集团用户使用协议",
            dangerouslyUseHTMLString: true,
            // message:'哈哈哈哈，嗯嗯，Just do it',
            message: str,
            confirmButtonColor: "red",
          })
          .then(() => {
            // console.log("点击了确认");
            this.$emit("isShow", false);
          })
          .catch(() => {
            // console.log("点击了取消");
            this.$emit("isShow", false);
          });
      }
    },
  },
};
</script>
<style lang='scss' scope>
.upload {
  .upbtn {
    text-align: right;
    // .btn {
    //     color: #fff;
    //     background-color: #409eff;
    //     border-color: #409eff;
    // }
  }
  .el-dialog__header {
    padding-left: 27px;
    .el-dialog__title {
      font-size: 12px;
    }
  }
  .el-dialog__body {
    padding: 30px 20px 0 20px;
    color: #606266;
    font-size: 12px;
    word-break: break-all;
    .el-form-item__label {
      font-size: 12px;
    }
    .el-form-item__content {
      line-height: 30px;
      position: relative;
      font-size: 12px;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-upload--text {
    width: initial;
    height: initial;
    border: none;
  }
  .fication {
    text-align: left;
    margin-bottom: 10px;
  }
  .jinggao {
    text-align: left;
    // color: red;
    margin-left: 5px;
    font-size: 14px;
    color: rgba(149, 149, 149, 1);
    margin-bottom: 10px;
  }
  /deep/.dialog-footer {
    color: red;
  }
  /deep/.el-dialog {
    // padding: 20px;
    // border-radius: 20px;
    // height: 70%;
    // width: 1200px;
    width: 100%;
    // height: 780px;
    overflow: auto;
    .el-form {
      box-sizing: border-box;
      // width: 1200px;
      height: 540px;
      overflow: auto;
    }
  }
  /deep/.van-dialog__message--has-title {
    text-align: left;
  }
}
</style>